'use client'

import { useState, useEffect } from 'react'

const COOKIE_KEY = 'obi_cookie_consent'

export default function CookieConsentBanner() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    // Only show if the user hasn't already consented
    try {
      const stored = localStorage.getItem(COOKIE_KEY)
      if (!stored) setVisible(true)
    } catch {
      // localStorage unavailable (e.g. private browsing in some browsers)
      setVisible(true)
    }
  }, [])

  function accept() {
    try { localStorage.setItem(COOKIE_KEY, 'accepted') } catch { /* ignore */ }
    setVisible(false)
  }

  function decline() {
    try { localStorage.setItem(COOKIE_KEY, 'declined') } catch { /* ignore */ }
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      style={{
        position: 'fixed',
        bottom: 24,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        width: 'min(560px, calc(100vw - 32px))',
        backgroundColor: '#1A1A18',
        color: '#fff',
        borderRadius: 14,
        padding: '18px 22px',
        boxShadow: '0 8px 40px rgba(0,0,0,0.35)',
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        flexWrap: 'wrap',
      }}
    >
      {/* Text */}
      <p style={{ flex: 1, margin: 0, fontSize: 13, lineHeight: 1.55, color: 'rgba(255,255,255,0.75)', minWidth: 200 }}>
        We use cookies to keep you signed in and improve your experience.{' '}
        <a
          href="/legal/privacy"
          style={{ color: 'rgba(255,255,255,0.9)', textDecoration: 'underline', whiteSpace: 'nowrap' }}
        >
          Privacy Policy
        </a>
      </p>

      {/* Buttons */}
      <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
        <button
          onClick={decline}
          style={{
            padding: '7px 14px',
            borderRadius: 8,
            border: '1px solid rgba(255,255,255,0.2)',
            backgroundColor: 'transparent',
            color: 'rgba(255,255,255,0.6)',
            fontSize: 12,
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'border-color 0.15s, color 0.15s',
          }}
          onMouseEnter={e => {
            const el = e.currentTarget as HTMLButtonElement
            el.style.borderColor = 'rgba(255,255,255,0.5)'
            el.style.color = 'rgba(255,255,255,0.9)'
          }}
          onMouseLeave={e => {
            const el = e.currentTarget as HTMLButtonElement
            el.style.borderColor = 'rgba(255,255,255,0.2)'
            el.style.color = 'rgba(255,255,255,0.6)'
          }}
        >
          Decline
        </button>
        <button
          onClick={accept}
          style={{
            padding: '7px 16px',
            borderRadius: 8,
            border: 'none',
            backgroundColor: '#2E5545',
            color: '#fff',
            fontSize: 12,
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'background-color 0.15s',
          }}
          onMouseEnter={e => { (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#24433A' }}
          onMouseLeave={e => { (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#2E5545' }}
        >
          Accept
        </button>
      </div>
    </div>
  )
}
